import { onDocumentReady } from "@theme/utilities";
import { CartAddEvent } from "@theme/events";

onDocumentReady(() => {
  /**
   * Handles custom events related to product cross-sell redirects.
   *
   * Extracts product data from the event's `detail.data` object and, if a cross-sell
   * redirect is indicated, navigates the user to the cross-sell page with the relevant
   * product details in the query parameters.
   *
   * @function eventHandler
   * @param {CartAddEvent} event - The custom add-to-cart event containing product data in `event.detail.data`.
   * @param {Object} event.detail.data - The data payload for the event.
   * @param {boolean} [event.detail.data.hasCrossSellRedirect=false] - Indicates whether a redirect should occur.
   * @param {string} [event.detail.data.productId] - The unique ID of the product.
   * @param {string} [event.detail.data.productHandle] - The handle (slug) of the product.
   * @param {string} [event.detail.data.variantId] - The unique ID of the product variant.
   */
  const eventHandler = (event) => {
    const baseUrl =
      document.querySelector("script[data-redirect-url]")?.dataset
        ?.redirectUrl || `/pages/helpful-additions`;

    const { hasCrossSellRedirect, productId, productHandle, variantId } =
      event?.detail?.data || {};

    if (hasCrossSellRedirect) {
      window.location.assign(
        `${baseUrl}?product=${productId}&variant=${variantId}&handle=${productHandle}`,
      );
    }
  };

  // Add event listener for custom add-to-cart event.
  document.addEventListener(CartAddEvent.eventName, eventHandler);
});
